module.exports = __webpack_public_path__ + "static/img/activate_head.0665bcc0.png";